import React, { useState } from "react";
import { Popover } from "antd";
import styles from "./ActionMenu.module.css";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

const ActionMenu = ({ options }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleClick = ({ route, action }) => {
    if (route) {
      navigate(route);
    } else if (action) {
      action();
    }
  };

  return (
    <Popover
      content={
        <div className={styles.menu_wrap}>
          {options.map((item) => {
            return (
              <div
                className={
                  styles.menu_item +
                  " " +
                  styles[item.label.toLowerCase() + "_label"]
                }
                onClick={() => handleClick(item)}
              >
                {item.label}
              </div>
            );
          })}
        </div>
      }
      title=""
      trigger="click"
      open={open}
      placement="bottom"
      onOpenChange={handleOpenChange}
    >
      <HiOutlineDotsVertical className={styles.filter_icon} />
    </Popover>
  );
};
export default ActionMenu;
